import React from "react";
import "./Timer.css";

const pad2 = (value) => String(Math.max(0, Number(value) || 0)).padStart(2, "0");

const safeLanguage = (infoSource, section, key) => {
  try {
    const value = infoSource?.language?.(infoSource, section, key);
    return typeof value === "string" && value ? value : null;
  } catch (error) {
    return null;
  }
};

// Unit labels from the existing translated catalogue (title.days, ...),
// with English fallbacks.
export const countdownLabels = (infoSource) => ({
  title: safeLanguage(infoSource, "title", "timeRemaining") || "Time remaining",
  days: safeLanguage(infoSource, "title", "days") || "Days",
  hours: safeLanguage(infoSource, "title", "hours") || "Hours",
  minutes: safeLanguage(infoSource, "title", "minutes") || "Minutes",
  seconds: safeLanguage(infoSource, "title", "seconds") || "Seconds",
});

/**
 * Four blocks, each number stacked directly above its own unit, so a value
 * can never drift away from its label. 4 columns when there is room, 2x2 in
 * a narrow container (container query, see Timer.css).
 */
const CountdownBlocks = ({ remaining, labels, severity = "normal", className = "" }) => {
  const units = [
    ["days", remaining?.days],
    ["hours", remaining?.hours],
    ["minutes", remaining?.minutes],
    ["seconds", remaining?.seconds],
  ];
  return (
    <div className={`elakay-countdown elakay-countdown--${severity} ${className}`} role="timer">
      <p className="elakay-countdown-title">{labels.title}</p>
      <div className="elakay-countdown-grid">
        {units.map(([unit, value]) => (
          <div className="elakay-countdown-unit" key={unit}>
            <span className="elakay-countdown-value">{pad2(value)}</span>
            <span className="elakay-countdown-label">{labels[unit]}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountdownBlocks;
